/* eslint-disable no-undef */
import React from 'react';
import styled from 'styled-components';
import { CustomBtn, HeadingMobile, Text } from '../Typography';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../Routes';
import { toast } from 'react-toastify';

const MainContainer = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    background: #e3f0ff;
    border-radius: 20px;
    width: 95%;
    margin: 0 auto;
    margin-bottom: 15px;
  }
`;
const TextMobile = styled(Text)`
  @media (max-width: 767px) {
    padding: 20px;
  }
`;
const ListItem = styled.li`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  padding: 10px;
`;
const ContributionText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  padding: 0 10px;
`;
// const ImportantTextContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   background: rgba(252, 170, 232, 0.2);
// `;
// const ImpText = styled.p`
//   font-family: 'Noto Sans';
//   font-style: normal;
//   font-weight: 600;
//   font-size: 12px;
//   text-align: center;
//   color: #f4422a;
//   padding: 10px 5px;
// `;

const ContriProcessMobile = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    const isContributionEnabled =
      process.env.REACT_APP_CONTRIBUTION_ENABLED === 'true';

    if (isContributionEnabled) {
      navigate(ROUTES.CONTRIBUTION_FIRST_PAGE);
    } else {
      toast.error('Contribution is not Enabled', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };
  return (
    <MainContainer>
      <HeadingMobile margin="20px">Online Contribution Process</HeadingMobile>
      <TextMobile>
        {' '}
        To make contribution through a direct transfer from your bank, through a
        secure Payment Gateway
      </TextMobile>
      <ul>
        <ListItem>Please enter the amount you wish to contribute</ListItem>
        <ListItem>
          Select the Bank from which you wish to pay. You will be re-directed to
          your Bank’s netbanking login page
        </ListItem>
        <ListItem>
          After confirming the payment you will be directed back to BSG’s
          Contribution site
        </ListItem>
      </ul>
      <ContributionText>
        {' '}
        Your contribution receipt will be mailed to you immediately on
        completion of transaction. In case of any query, please write to us at{' '}
        <a href="/">contribution@bharatsokagakkai.org</a>
      </ContributionText>
      {/* <ImportantTextContainer>
        <ImpText>
          Important-Please check your Name and Address displayed above, to
          ensure that they are correct. As the Contribution Receipt will be
          generated on the same. In case they are not correct. Please DO NOT
          proceed, and contact your District Stats Coordinator or District
          Leader for getting the corrections made. Please make the contributions
          only after the corrections have been done.
        </ImpText>
      </ImportantTextContainer> */}
      <CustomBtn marginTop="20px" marginBottom="20px" onClick={handleClick}>
        <Button>Click here to Contribute</Button>
      </CustomBtn>
    </MainContainer>
  );
};

export default ContriProcessMobile;
